import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatus = ({ status, message }) => {
  const statusConfig = {
    online: {
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20',
      label: 'System Online'
    },
    maintenance: {
      icon: 'AlertTriangle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20',
      label: 'Wartungsmodus'
    },
    offline: {
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20',
      label: 'System Offline'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.online;

  return (
    <div className={`flex items-start gap-3 p-4 ${config?.bgColor} border ${config?.borderColor} rounded-lg`}>
      <Icon name={config?.icon} size={20} className={`${config?.color} flex-shrink-0 mt-0.5`} />
      <div className="flex-1">
        <h4 className={`text-sm font-semibold ${config?.color} mb-1`}>
          {config?.label}
        </h4>
        {message && (
          <p className="text-sm text-muted-foreground">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default SystemStatus;